var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent is-half" }, [
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _c("div", { staticClass: "columns is-gapless" }, [
          _vm._m(0),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field is-pulled-right" }, [
              _c("p", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button is-primary tooltip is-tooltip-topright",
                    attrs: { "data-tooltip": "Add new auto item" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleList()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "mdi",
                        class: {
                          "mdi-plus": !_vm.showMiscItemList,
                          "mdi-minus": _vm.showMiscItemList,
                        },
                      }),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.buttonText))]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _c("available-miscs", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMiscItemList,
              expression: "showMiscItemList",
            },
          ],
          attrs: {
            "item-type": "MISC",
            "insurer-id": _vm.entity.insurerId,
            "page-size": 8,
          },
          model: {
            value: _vm.entity.insurerAutoItems,
            callback: function ($$v) {
              _vm.$set(_vm.entity, "insurerAutoItems", $$v)
            },
            expression: "entity.insurerAutoItems",
          },
        }),
        _vm.showMiscItemList
          ? _c("div", { staticClass: "is-divider" })
          : _vm._e(),
        _c(
          "table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          },
          [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.activeItems, function (autoItem, index) {
                return _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !autoItem.isDeleted,
                        expression: "!autoItem.isDeleted",
                      },
                    ],
                    key: autoItem.autoItemId,
                  },
                  [
                    _c("td", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(autoItem.itemNo)),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: autoItem.itemDesc,
                              expression: "autoItem.itemDesc",
                            },
                            {
                              name: "focus-inserted",
                              rawName: "v-focus-inserted",
                            },
                          ],
                          staticClass: "input",
                          attrs: { placeholder: "" },
                          domProps: { value: autoItem.itemDesc },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                autoItem,
                                "itemDesc",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("td", { staticClass: "has-text-right" }, [
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: { min: 0, precision: 2 },
                            model: {
                              value: autoItem.price,
                              callback: function ($$v) {
                                _vm.$set(autoItem, "price", $$v)
                              },
                              expression: "autoItem.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "td",
                      { staticClass: "has-vertical-middle has-text-centered" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: autoItem.reportOnly,
                              expression: "autoItem.reportOnly",
                            },
                          ],
                          staticClass: "is-checkradio is-circle is-primary",
                          class: {
                            "has-background-color": autoItem.reportOnly,
                          },
                          attrs: {
                            id: `report${index}`,
                            name: `report${index}`,
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(autoItem.reportOnly)
                              ? _vm._i(autoItem.reportOnly, null) > -1
                              : autoItem.reportOnly,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = autoItem.reportOnly,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      autoItem,
                                      "reportOnly",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      autoItem,
                                      "reportOnly",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(autoItem, "reportOnly", $$c)
                              }
                            },
                          },
                        }),
                        _c("label", {
                          attrs: {
                            for: `report${index}`,
                            "data-label-empty": "",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "td",
                      { staticClass: "has-vertical-middle has-text-centered" },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "button is-danger is-small is-inverted",
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem(autoItem, index)
                              },
                            },
                          },
                          [_vm._m(2, true)]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Auto Items")]),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("Add automatic miscellaneous items"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Item No")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [
          _c("div", { staticClass: "has-text-right" }, [_vm._v("Value")]),
        ]),
        _c("th", [
          _c("div", { staticClass: "has-text-centered" }, [_vm._v("Rpt")]),
        ]),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }